/* =====================================================================
   Ayarlar (localStorage) — "kesinlesme.html" ile AYNI anahtar şeması.
   tazkom_kesinlesme_ayar anahtarı paylaşımlıdır; HTML'i kullanmış olanların
   ayarı taşınır. ayarOku doğrular ve eksik/bozuk alanlar için fallback verir.

   Not: HTML'deki `tiklaSil` (alana girince mevcut tarihi sil) bilinçli olarak
   düşürüldü (CustomDatePicker'ın value↔localDate senkronuyla çakışıyordu).
   Bilinmeyen eski anahtarlar okunurken yok sayılır.
   ===================================================================== */

import { ekBayramlariTemizle } from './diniBayramlar';
import { REJIMLER } from './adliTatil';

export const STORAGE_KEY = 'tazkom_kesinlesme_ayar';
export const VARSAYILAN_SURE = 15;
export const VARSAYILAN_BIRIM = 'gun';
export const VARSAYILAN_ADLI_TATIL = 'kapali';
export const BIRIMLER = ['gun', 'hafta', 'ay'];
// İlk açılışta (favoriler hiç kaydedilmemişse) ana ekranda görünecek favori preset id'leri.
export const VARSAYILAN_FAVORILER = [
  'manuel',
  'istinaf-hukuk', 'temyiz-hukuk',
  'istinaf-ceza', 'temyiz-ceza', 'itiraz-ceza',
  'istinaf-ceza-eski', 'temyiz-ceza-eski', 'itiraz-ceza-eski',
  'aym-bireysel',
];

export function birimAdi(b) {
  return b === 'hafta' ? 'hafta' : b === 'ay' ? 'ay' : 'gün';
}

/** Kullanıcı preset listesini doğrular: ad dolu, süre 1–999, geçerli birim/rejim; tekrar id'leri eler. */
export function presetleriTemizle(arr) {
  if (!Array.isArray(arr)) return [];
  const out = [];
  for (const p of arr) {
    if (!p || typeof p.ad !== 'string' || !p.ad.trim()) continue;
    const s = Number(p.sure);
    if (!(s >= 1 && s <= 999)) continue;
    if (!BIRIMLER.includes(p.birim)) continue;
    const adliTatil = REJIMLER.includes(p.adliTatil) ? p.adliTatil : 'kapali';
    const id = (typeof p.id === 'string' && p.id) ? p.id : `u-${out.length}-${p.ad.trim().slice(0, 12)}`;
    if (out.some((x) => x.id === id)) continue;
    out.push({ id, ad: p.ad.trim().slice(0, 60), sure: Math.floor(s), birim: p.birim, adliTatil });
  }
  return out;
}

export function ayarOku() {
  const bos = {
    defaultSure: VARSAYILAN_SURE,
    defaultBirim: VARSAYILAN_BIRIM,
    showSure: true,
    autoHesap: true,
    silinceSifirla: true,
    adliTatil: VARSAYILAN_ADLI_TATIL,
    hazirSureGoster: true,
    presetler: [],
    favoriler: VARSAYILAN_FAVORILER,
    ekBayramlar: [],
  };
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return bos;
    const obj = JSON.parse(raw);
    const s = Number(obj.defaultSure);
    return {
      defaultSure: (s >= 1 && s <= 999) ? Math.floor(s) : VARSAYILAN_SURE,
      defaultBirim: BIRIMLER.includes(obj.defaultBirim) ? obj.defaultBirim : VARSAYILAN_BIRIM,
      showSure: obj.showSure !== false,
      autoHesap: obj.autoHesap !== false,
      silinceSifirla: obj.silinceSifirla !== false,
      adliTatil: REJIMLER.includes(obj.adliTatil) ? obj.adliTatil : VARSAYILAN_ADLI_TATIL,
      hazirSureGoster: obj.hazirSureGoster !== false,
      presetler: presetleriTemizle(obj.presetler),
      // Hiç kaydedilmemişse başlangıç favorileri; kaydedilmişse (boş dahi olsa) olduğu gibi.
      favoriler: Array.isArray(obj.favoriler) ? obj.favoriler.filter((x) => typeof x === 'string') : VARSAYILAN_FAVORILER,
      ekBayramlar: ekBayramlariTemizle(obj.ekBayramlar),
    };
  } catch {
    return bos;
  }
}

export function ayarYaz(ayar) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ayar));
  } catch {
    /* kota dolu / gizli mod — sessiz geç */
  }
}
